import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import { JAPAN_DX_ONBOARDING_PLATFORM_MIGRATION } from '../../../../../../experimentConstants'

export function isPlatformWorkflowStep() {
  const isEnablePlatformMigration = isFeatureFlagEnabled(
    JAPAN_DX_ONBOARDING_PLATFORM_MIGRATION
  )
  return isEnablePlatformMigration
}
